import React, { useState, useEffect } from "react";
import { MsalAuthenticationTemplate, useMsal } from "@azure/msal-react";
import {
  InteractionType,
} from "@azure/msal-browser";
import { loginRequest } from "../authConfig";

// Sample app imports
import { ShipmentProcessFormContent } from "../components/SalesOrder/ShipmentProcessFormContent";
import { Loading } from "../components/Loading";
import { ErrorComponent } from "../components/ErrorComponent";
import { api_path } from "../shared";

export function ShipmentProcessForm() {
  const authRequest = {
    ...loginRequest,
  };
  const [getUserRole, setUserRole] = useState();
  const [getEmpCode, setEmpCode] = useState();
  const [getUserEMail, setUserEmail] = useState("");
  const { accounts } = useMsal();
  useEffect(() => {
    setUserEmail(accounts[0]?.username);
    fetchUserRole(accounts[0]?.username);
    if(!getUserRole){
      window.location = "/s-crm/Home?status=denined";
    }
  });
  const ShipmentProcessContent = () => {
    return <ShipmentProcessFormContent 
    USER_EMAIL={accounts[0]?.username}
    EMP_CODE={getEmpCode}
    USER_ROLE={getUserRole}
    />;
  };
  
  function fetchUserRole(userEmail) {
    fetch(api_path + "/USER_ROLE.php?USER_EMAIL=" + userEmail)
      .then((res) => res.json())
      .then((res) => {
        const array = res;
        for (const i of array) {
          setUserRole(i.USER_ROLE_ID);
          setEmpCode(i.EMP_CODE);
        }
      });
  }
  useEffect(() => {
    var data = {
      ROLE_ID: getUserRole,
      USER_EMAIL: getUserEMail,
      MENU_URL:window.location.pathname,
    };
    fetch(api_path + "/GET_AUTHEN_URL.php", {
      method: "POST",
      headers: {
        Accept: "application/form-data",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log("status " +result["status"])
        console.log("success " +result["success"])
          if (result["status"] == "200") {
            if (result["success"] == "0") {
              window.location = "/s-crm/Home?status=denined";
            }
          }
      });
  }, []);
  return (
    <MsalAuthenticationTemplate
      interactionType={InteractionType.Redirect}
      authenticationRequest={authRequest}
      errorComponent={ErrorComponent}
      loadingComponent={Loading}
    >
      <getAccount />
      <ShipmentProcessContent />
    </MsalAuthenticationTemplate>
  );
}
